// extracted by mini-css-extract-plugin
export default {"item":"SendTicketModal_item__uOzUv","form":"SendTicketModal_form__CDKJL"};